export const EMAIL = 'info@windowwizards.cc';
export const PHONE = '720-466-1749';
export const PHONE_HREF = 'tel:+17204661749';

const subject = 'Quote request — Window Wizards';
const body = [
  'Hi Window Wizards,',
  '',
  "I'd like a quote for window care.",
  '',
  'Name:',
  'Property address:',
  'Residential or commercial:',
  'Number of stories:',
  'Approx. window count:',
  'Interior, exterior, or both:',
  'Preferred timing:',
  'Anything else:',
  '',
  'Thank you.',
].join('\n');

export const QUOTE_MAILTO = `mailto:${EMAIL}?subject=${encodeURIComponent(
  subject
)}&body=${encodeURIComponent(body)}`;
